/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { AiDescriptionResponse } from '../models/AiDescriptionResponse';
import type { BulkPatchVisitsResponseSchema } from '../models/BulkPatchVisitsResponseSchema';
import type { BulkPatchVisitsSchema } from '../models/BulkPatchVisitsSchema';
import type { CancelVisitReceiptsSchema } from '../models/CancelVisitReceiptsSchema';
import type { CheckVisitSchema } from '../models/CheckVisitSchema';
import type { CheckVisitValidityResponseSchema } from '../models/CheckVisitValidityResponseSchema';
import type { CreateVisitSchema } from '../models/CreateVisitSchema';
import type { FTActionVisitPatchSchema } from '../models/FTActionVisitPatchSchema';
import type { FTTicketActionVisitDetailSchema } from '../models/FTTicketActionVisitDetailSchema';
import type { GenerateVisitsReportSchema } from '../models/GenerateVisitsReportSchema';
import type { ImproveDescriptionRequest } from '../models/ImproveDescriptionRequest';
import type { NextAppointmentSchema } from '../models/NextAppointmentSchema';
import type { PagedVisitListSchema } from '../models/PagedVisitListSchema';
import type { PatchVisitCalendarNoteSchema } from '../models/PatchVisitCalendarNoteSchema';
import type { PatchVisitSchema } from '../models/PatchVisitSchema';
import type { ReceiptReadSchema } from '../models/ReceiptReadSchema';
import type { RecurringVisitDeleteStrategyChoices } from '../models/RecurringVisitDeleteStrategyChoices';
import type { RescheduleSuggestionsResponseSchema } from '../models/RescheduleSuggestionsResponseSchema';
import type { RescheduleSuggestionsSchema } from '../models/RescheduleSuggestionsSchema';
import type { ResetDiagnosticCustomerUsersSchema } from '../models/ResetDiagnosticCustomerUsersSchema';
import type { SetVisitStatusSchema } from '../models/SetVisitStatusSchema';
import type { StatusChangePreviewSchema } from '../models/StatusChangePreviewSchema';
import type { TimeSlotOverviewSchema } from '../models/TimeSlotOverviewSchema';
import type { UpdateVisitSchema } from '../models/UpdateVisitSchema';
import type { VisitCalendarNoteSchema } from '../models/VisitCalendarNoteSchema';
import type { VisitDetailSchema } from '../models/VisitDetailSchema';
import type { VisitFormSchema } from '../models/VisitFormSchema';
import type { VisitImageSchema } from '../models/VisitImageSchema';
import type { VisitInsuranceSuggestionRequestSchema } from '../models/VisitInsuranceSuggestionRequestSchema';
import type { VisitInsuranceSuggestionSchema } from '../models/VisitInsuranceSuggestionSchema';
import type { VisitReceiptCreateSchema } from '../models/VisitReceiptCreateSchema';
import type { VisitsReportSchema } from '../models/VisitsReportSchema';
import type { VisitStatus } from '../models/VisitStatus';
import type { VisitTimeSlotSchema } from '../models/VisitTimeSlotSchema';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class VisitsApi {
    /**
     * Get Available Timeslots For Visit
     * Get available time slots for a given service and date.<br> Required Permission: get_available_time_slots_for_visit
     * @returns VisitTimeSlotSchema OK
     * @throws ApiError
     */
    public static visitsGetAvailableTimeslotsForVisitGet({
        serviceId,
        date,
        locationId,
        userIds,
        diagnosticId,
        patientNin,
        visitId,
        firstVisitInBatchDateTime,
    }: {
        serviceId: string,
        date: string,
        locationId?: (string | null),
        userIds?: (Array<string> | null),
        diagnosticId?: (string | null),
        patientNin?: (string | null),
        visitId?: (string | null),
        firstVisitInBatchDateTime?: (string | null),
    }): CancelablePromise<Array<VisitTimeSlotSchema>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/v1/visits/time-slots/',
            query: {
                'service_id': serviceId,
                'date': date,
                'location_id': locationId,
                'user_ids': userIds,
                'diagnostic_id': diagnosticId,
                'patient_nin': patientNin,
                'visit_id': visitId,
                'first_visit_in_batch_date_time': firstVisitInBatchDateTime,
            },
        });
    }
    /**
     * Get Available Timeslots Overview For Visit
     * Get available time slots overview (per day) for a given service and month.<br> Required Permission: get_available_time_slots_for_visit
     * @returns TimeSlotOverviewSchema OK
     * @throws ApiError
     */
    public static visitsGetAvailableTimeslotsOverviewForVisitGet({
        serviceId,
        date,
        locationId,
        userIds,
        diagnosticId,
        patientNin,
        visitId,
        firstVisitInBatchDateTime,
    }: {
        serviceId: string,
        date: string,
        locationId?: (string | null),
        userIds?: (Array<string> | null),
        diagnosticId?: (string | null),
        patientNin?: (string | null),
        visitId?: (string | null),
        firstVisitInBatchDateTime?: (string | null),
    }): CancelablePromise<Array<TimeSlotOverviewSchema>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/v1/visits/time-slots/overview/',
            query: {
                'service_id': serviceId,
                'date': date,
                'location_id': locationId,
                'user_ids': userIds,
                'diagnostic_id': diagnosticId,
                'patient_nin': patientNin,
                'visit_id': visitId,
                'first_visit_in_batch_date_time': firstVisitInBatchDateTime,
            },
        });
    }
    /**
     * Generate Visits Report
     * Generate a medical report based on a list of visits.
     * @returns VisitsReportSchema OK
     * @throws ApiError
     */
    public static visitsGenerateVisitsReportPost({
        requestBody,
    }: {
        requestBody: GenerateVisitsReportSchema,
    }): CancelablePromise<VisitsReportSchema> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/v1/visits/visits-report/',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * Improve Visit Description
     * Improve a visit description using AI. Requires AI features to be enabled in company settings.
     * @returns AiDescriptionResponse OK
     * @throws ApiError
     */
    public static visitsImproveVisitDescriptionPost({
        visitId,
        requestBody,
    }: {
        visitId: string,
        requestBody: ImproveDescriptionRequest,
    }): CancelablePromise<AiDescriptionResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/v1/visits/{visit_id}/ai-improve-description/',
            path: {
                'visit_id': visitId,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * Bulk Patch Visits
     * Bulk change of visit therapist and/or date, processed asynchronously. <br>Required Permission: update_visit
     * @returns BulkPatchVisitsResponseSchema Accepted
     * @throws ApiError
     */
    public static visitsBulkPatchVisitsPatch({
        requestBody,
    }: {
        requestBody: BulkPatchVisitsSchema,
    }): CancelablePromise<BulkPatchVisitsResponseSchema> {
        return __request(OpenAPI, {
            method: 'PATCH',
            url: '/v1/visits/bulk/',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * Reschedule Suggestions
     * Suggest new dates for a batch of visits without modifying them. <br>Required Permission: update_visit
     * @returns RescheduleSuggestionsResponseSchema OK
     * @throws ApiError
     */
    public static visitsRescheduleSuggestionsPost({
        requestBody,
    }: {
        requestBody: RescheduleSuggestionsSchema,
    }): CancelablePromise<RescheduleSuggestionsResponseSchema> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/v1/visits/reschedule-suggestions/',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * Cancel Visit Receipts
     * Cancel receipts for this visit and refund the subscription/ticket if applicable.
     * @returns VisitDetailSchema OK
     * @throws ApiError
     */
    public static visitsCancelVisitReceiptsPost({
        visitId,
        requestBody,
    }: {
        visitId: string,
        requestBody?: (CancelVisitReceiptsSchema | null),
    }): CancelablePromise<VisitDetailSchema> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/v1/visits/{visit_id}/cancel-receipts/',
            path: {
                'visit_id': visitId,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * Check Visit
     * Check visit validity
     * @returns CheckVisitValidityResponseSchema OK
     * @throws ApiError
     */
    public static visitsCheckVisitPost({
        requestBody,
    }: {
        requestBody: CheckVisitSchema,
    }): CancelablePromise<CheckVisitValidityResponseSchema> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/v1/visits/validate/',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * Create Visit
     * Create a new visit. <br>Required Permission: create_visit
     * @returns VisitDetailSchema Created
     * @throws ApiError
     */
    public static visitsCreateVisitPost({
        requestBody,
    }: {
        requestBody: CreateVisitSchema,
    }): CancelablePromise<VisitDetailSchema> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/v1/visits/',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * Get Visit List
     * Get list of visits.<br>Use order_by'-date' or 'date' or '-end_date' or '-end_date'. <br>Required Permission: list_visits
     * @returns PagedVisitListSchema OK
     * @throws ApiError
     */
    public static visitsGetVisitListGet({
        query,
        patientId,
        userId,
        userIds,
        roomId,
        waiting,
        startDate,
        endDate,
        searchTerm,
        paid,
        orderBy,
        includeGroupVisits = false,
        serviceId,
        statuses,
        limit = 100,
        offset,
    }: {
        query?: 'NEXT' | 'PAST' | 'ALL',
        patientId?: (string | null),
        /**
         * @deprecated
         */
        userId?: (string | null),
        userIds?: (Array<string> | null),
        roomId?: (string | null),
        waiting?: (boolean | null),
        startDate?: (string | null),
        endDate?: (string | null),
        searchTerm?: (string | null),
        paid?: (boolean | null),
        orderBy?: (string | null),
        includeGroupVisits?: boolean,
        serviceId?: (string | null),
        /**
         * Only return visits in these statuses. Omit for all statuses.
         */
        statuses?: (Array<VisitStatus> | null),
        limit?: number,
        offset?: number,
    }): CancelablePromise<PagedVisitListSchema> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/v1/visits/',
            query: {
                'query': query,
                'patient_id': patientId,
                'user_id': userId,
                'user_ids': userIds,
                'room_id': roomId,
                'waiting': waiting,
                'start_date': startDate,
                'end_date': endDate,
                'search_term': searchTerm,
                'paid': paid,
                'order_by': orderBy,
                'include_group_visits': includeGroupVisits,
                'service_id': serviceId,
                'statuses': statuses,
                'limit': limit,
                'offset': offset,
            },
        });
    }
    /**
     * Delete Visit
     * Delete visit. <br>Required Permission: remove_visit
     * @returns void
     * @throws ApiError
     */
    public static visitsDeleteVisitDelete({
        visitId,
        recurringVisitsStrategy,
    }: {
        visitId: string,
        recurringVisitsStrategy?: (RecurringVisitDeleteStrategyChoices | null),
    }): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/v1/visits/{visit_id}/',
            path: {
                'visit_id': visitId,
            },
            query: {
                'recurring_visits_strategy': recurringVisitsStrategy,
            },
        });
    }
    /**
     * Get Visit
     * Update visit. <br>Required Permission: get_visit_detail
     * @returns VisitDetailSchema OK
     * @throws ApiError
     */
    public static visitsGetVisitGet({
        visitId,
    }: {
        visitId: string,
    }): CancelablePromise<VisitDetailSchema> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/v1/visits/{visit_id}/',
            path: {
                'visit_id': visitId,
            },
        });
    }
    /**
     * Patch Visit
     * Patch visit. <br>Required Permission: update_visit
     * @returns VisitDetailSchema OK
     * @throws ApiError
     */
    public static visitsPatchVisitPatch({
        visitId,
        requestBody,
    }: {
        visitId: string,
        requestBody: PatchVisitSchema,
    }): CancelablePromise<VisitDetailSchema> {
        return __request(OpenAPI, {
            method: 'PATCH',
            url: '/v1/visits/{visit_id}/',
            path: {
                'visit_id': visitId,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * Update Visit
     * Update visit. If the user has the 'update_visit' permission, the entire visit is updated; otherwise, only partial updates are allowed.
     * @returns VisitDetailSchema OK
     * @throws ApiError
     */
    public static visitsUpdateVisitPut({
        visitId,
        requestBody,
    }: {
        visitId: string,
        requestBody: UpdateVisitSchema,
    }): CancelablePromise<VisitDetailSchema> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/v1/visits/{visit_id}/',
            path: {
                'visit_id': visitId,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * Delete Visit Form
     * Delete visit-form. <br>Required permission: delete_visit_form
     * @returns void
     * @throws ApiError
     */
    public static visitsDeleteVisitFormDelete({
        formId,
    }: {
        formId: number,
    }): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/v1/visits/visit-forms/{form_id}/',
            path: {
                'form_id': formId,
            },
        });
    }
    /**
     * Delete Visit Image
     * Delete visit-image. <br>Required permission: delete_visit_image
     * @returns void
     * @throws ApiError
     */
    public static visitsDeleteVisitImageDelete({
        imageId,
    }: {
        imageId: number,
    }): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/v1/visits/visit-images/{image_id}/',
            path: {
                'image_id': imageId,
            },
        });
    }
    /**
     * Get Visit Insurance Suggestion
     * Get insurance reporting suggestion for the actions drafted on a visit, before they are saved. <br>Required Permission: get_visit_detail
     * @returns VisitInsuranceSuggestionSchema OK
     * @throws ApiError
     */
    public static visitsGetVisitInsuranceSuggestionPost({
        visitId,
        requestBody,
    }: {
        visitId: string,
        requestBody: VisitInsuranceSuggestionRequestSchema,
    }): CancelablePromise<VisitInsuranceSuggestionSchema> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/v1/visits/{visit_id}/insurance-suggestion/',
            path: {
                'visit_id': visitId,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * Get Visit Access Check
     * Check if the user can access the visit. <br>Required Permission: get_visit_detail
     * @returns void
     * @throws ApiError
     */
    public static visitsGetVisitAccessCheckGet({
        visitId,
    }: {
        visitId: string,
    }): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/v1/visits/{visit_id}/access-check/',
            path: {
                'visit_id': visitId,
            },
        });
    }
    /**
     * Get Visit Form List
     * List visit forms. <br>Required Permission: list_visit_forms
     * @returns VisitFormSchema OK
     * @throws ApiError
     */
    public static visitsGetVisitFormListGet({
        visitId,
    }: {
        visitId: string,
    }): CancelablePromise<Array<VisitFormSchema>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/v1/visits/{visit_id}/visit-forms/',
            path: {
                'visit_id': visitId,
            },
        });
    }
    /**
     * Upload Visit Form
     * Upload visit form. <br>Required Permission: upload_visit_form
     * @returns VisitFormSchema Created
     * @throws ApiError
     */
    public static visitsUploadVisitFormPost({
        visitId,
        formData,
    }: {
        visitId: string,
        formData: {
            file: Blob;
        },
    }): CancelablePromise<VisitFormSchema> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/v1/visits/{visit_id}/visit-forms/',
            path: {
                'visit_id': visitId,
            },
            formData: formData,
            mediaType: 'multipart/form-data',
        });
    }
    /**
     * Get Visit Image List
     * List visit images. <br>Required Permission: list_visit_images
     * @returns VisitImageSchema OK
     * @throws ApiError
     */
    public static visitsGetVisitImageListGet({
        visitId,
    }: {
        visitId: string,
    }): CancelablePromise<Array<VisitImageSchema>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/v1/visits/{visit_id}/visit-images/',
            path: {
                'visit_id': visitId,
            },
        });
    }
    /**
     * Upload Visit Image
     * Upload visit image. <br>Required Permission: upload_visit_image
     * @returns VisitImageSchema Created
     * @throws ApiError
     */
    public static visitsUploadVisitImagePost({
        visitId,
        formData,
    }: {
        visitId: string,
        formData: {
            image: Blob;
        },
    }): CancelablePromise<VisitImageSchema> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/v1/visits/{visit_id}/visit-images/',
            path: {
                'visit_id': visitId,
            },
            formData: formData,
            mediaType: 'multipart/form-data',
        });
    }
    /**
     * Patch Ft Action Visit
     * Patch visit. <br>Required Permission: update_ft_action_visit
     * @returns FTTicketActionVisitDetailSchema OK
     * @throws ApiError
     */
    public static visitsPatchFtActionVisitPatch({
        visitId,
        ftActionVisitId,
        requestBody,
    }: {
        visitId: string,
        ftActionVisitId: string,
        requestBody: FTActionVisitPatchSchema,
    }): CancelablePromise<FTTicketActionVisitDetailSchema> {
        return __request(OpenAPI, {
            method: 'PATCH',
            url: '/v1/visits/{visit_id}/ft-action-visits/{ft_action_visit_id}/',
            path: {
                'visit_id': visitId,
                'ft_action_visit_id': ftActionVisitId,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * Patch Visit Calendar Note
     * Set the calendar note of a single visit. Unlike the general visit patch this never touches the other occurrences of a recurring visit and works on signed visits too. <br>Required Permission: update_visit
     * @returns VisitCalendarNoteSchema OK
     * @throws ApiError
     */
    public static visitsPatchVisitCalendarNotePatch({
        visitId,
        requestBody,
    }: {
        visitId: string,
        requestBody: PatchVisitCalendarNoteSchema,
    }): CancelablePromise<VisitCalendarNoteSchema> {
        return __request(OpenAPI, {
            method: 'PATCH',
            url: '/v1/visits/{visit_id}/calendar-note/',
            path: {
                'visit_id': visitId,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * Pay For Visit
     * Pay for this visit and create a receipt. Required Permission: create_self_receipt
     * @returns ReceiptReadSchema OK
     * @throws ApiError
     */
    public static visitsPayForVisitPost({
        visitId,
        requestBody,
    }: {
        visitId: string,
        requestBody: VisitReceiptCreateSchema,
    }): CancelablePromise<Array<ReceiptReadSchema>> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/v1/visits/{visit_id}/pay-for-visit/',
            path: {
                'visit_id': visitId,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * Reset Diagnostic Customer Users
     * Reset next appointment's customer users to those from the diagnostic.
     * @returns NextAppointmentSchema OK
     * @throws ApiError
     */
    public static visitsResetDiagnosticCustomerUsersPost({
        requestBody,
    }: {
        requestBody: ResetDiagnosticCustomerUsersSchema,
    }): CancelablePromise<NextAppointmentSchema> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/v1/visits/next-appointment/reset-diagnostic-customer-users/',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * Set Visit Status
     * Set the visit status. With dry_run=true returns a preview of the financial consequence instead of applying anything, so the UI can confirm before money moves. <br>Required Permission: update_visit (+ create_self_receipt / create_receipt_for_colleague when a document would be issued)
     * @returns any OK
     * @throws ApiError
     */
    public static visitsSetVisitStatusPost({
        visitId,
        requestBody,
    }: {
        visitId: string,
        requestBody: SetVisitStatusSchema,
    }): CancelablePromise<(VisitDetailSchema | StatusChangePreviewSchema)> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/v1/visits/{visit_id}/status/',
            path: {
                'visit_id': visitId,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
}
